import VaccinationForm from "../../components/forms/vaccinationForm";
import VaccinationTable from "../../components/tables/vaccinationTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, vaccinationCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const Vaccinations = () => {
  const { selectedChild } = useChild();
  const { items: vaccinationData, addItem, updateItem, deleteItem, loading, error } = useFirestore("vaccinations", selectedChild?.id);

  const handleAdd = async (vaccination) => {
    try {
      await addItem({ ...vaccination, childId: selectedChild?.id });
    } catch (err) {
      console.error("Error adding vaccination:", err);
    }
  };

  const handleExport = () => {
    exportToCSV(vaccinationData, `vaccinations-${selectedChild?.name || "export"}.csv`, vaccinationCSVColumns);
  };

  const handleExportPDF = () => {
    exportSectionPDF(vaccinationData, `vaccinations-${selectedChild?.name || "export"}.pdf`, vaccinationCSVColumns, "Vaccinations", selectedChild?.name || "");
  };

  return (
    <div className="card h-100" id="vaccinations">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title mb-0">💉 Vaccinations</h5>
          <div className="d-flex gap-1">
            <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
            <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <VaccinationForm onAdd={handleAdd} />
        {loading ? (
          <LoadingState message="Loading vaccinations..." />
        ) : vaccinationData.length > 0 ? (
          <VaccinationTable data={vaccinationData} onUpdate={updateItem} onDelete={deleteItem} />
        ) : (
          <EmptyState
            icon="💉"
            heading="No vaccinations recorded yet"
            message="Keep track of every immunisation so nothing gets missed."
          />
        )}
      </div>
    </div>
  );
};

export default Vaccinations;
